module.exports = __webpack_public_path__ + "static/img/ptealto.05de94fd.png";